import { ref } from '@nuxtjs/composition-api';
import useStaticContent from '@/hooks/useStaticContent/useStaticContent';

const isInitialized = false;

const bambeeHours = ref('');

const setupHook = async () => {
  const staticContent = useStaticContent();
  staticContent.fetchContent('businessHours').then(
    (response) => {
      bambeeHours.value = response.text;
    }
  );
};

const useGlobalInfo = () => {
  if (!isInitialized) {
    setupHook();
  }

  return {
    bambeeHours,
  };
};

export default useGlobalInfo;
